
import wx from 'weixin-js-sdk'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Group from 'vux/src/components/group/index.vue'


export default {
components: {
wx,XTextarea,Group
},
data() {
return {
subStatus: true,
popUp: false,
rechargePop: false,
orderShow: false,
clotheShow: false,
colorShow: false,
flawShow: false,
bagCode:'',
totalAmount:0,
expressAmount:0,
order_no:'',
type:0,
number:0,
order: {
community:{
name:''
},
},
froms:[
{
name:'',
phone:'',
bag_code:'',
clothe_id:0,
color_id:0,
flaw_id:[],
clothe:'选择衣物',

color:'选择颜色',
filePath: [],
pics:[],
remark:'',
}
],
clotheIndex:0,
colorIndex:0,
flawIndex:0,
picIndex:0,
clothes: [],
colors: [],
flaws: [],
expressFee: [],
info:{}
}
},
created() {





this.getWashCategoryGoods();
},
mounted(){
this.config();

},
methods: {
getInfo(){
this.$api.getInfo({}).then((res)=>{
if(res){
this.info = res.data;
}
})
},
addModules(){
let num = this.froms.length;
if(num >= this.expressFee[this.expressFee.length - 1].num){
this.$func.showToast('单个包裹最多下单' + this.expressFee[this.expressFee.length - 1].num + '件');
return false;
}
this.froms.push({
name:'',
phone:'',
bag_code:'',
price:0,
clothe_id:0,
price:0,
color_id:0,
flaw_id:[],
clothe:'选择衣物',

color:'选择颜色',
filePath: [],
pics:[],
});
},
removeModules(index){
let that = this;
this.$func.confirm('确认移除 ”衣物'+(index+1)+'“ ？','提示',()=>{
that.froms.splice(index, 1);
})
},
scanQRCode(key,index){
let that = this;
wx.ready(()=> {
wx.scanQRCode({
needResult: 1,
scanType: ['barCode'],
success: function (res) {
setTimeout(()=>{

that.froms[index].bag_code = res.resultStr.split(',')[1];




},300);
}
})
});
wx.error((res)=> {
console.log(res)

})
},
getWashCategoryGoods() {
this.$api.getWashCategoryGoods({}).then((res)=>{
if(res){
this.clothes = res.data.goods;
this.colors = res.data.colors;
this.expressFee = res.data.expressFee;

}
})
},






















openClotheShow(index){
this.clotheIndex = index;
this.popUp = true;
this.clotheShow = true;
},
openClotheColor(index){
this.colorIndex = index;
this.popUp = true;
this.colorShow = true;
},
openClotheFlaw(index){
this.flawIndex = index;
this.popUp = true;
this.flawShow = true;
},
closePop(){
this.popUp = false;
this.rechargePop = false;
this.orderShow = false;
this.clotheShow = false;
this.colorShow = false;
this.flawShow = false;
this.clotheIndex = 0;
this.colorIndex = 0;
this.flawIndex = 0;
this.amount = 0;
},
clotheSelect(i){
this.froms[this.clotheIndex].clothe_id = this.clothes[i].id;
this.froms[this.clotheIndex].clothe = this.clothes[i].title;
this.froms[this.clotheIndex].price = this.clothes[i].price;
this.countPrice();
this.closePop();
},
colorSelect(id,title){
this.froms[this.colorIndex].color_id = id;
this.froms[this.colorIndex].color = title;
this.closePop();
},
countPrice(){
let that = this,exAmount = 0,number1=0;
number1 = this.froms.length;
let status = false;
for (let item of this.expressFee) {
if(item.num == number1){
exAmount = item.amount;
status = true;
break;
}
}
if(!status){
this.$func.showToast('单个包裹最多下单' + this.expressFee[this.expressFee.length - 1].num + '件');
return false;
}
this.number = number1;
this.expressAmount = exAmount;
this.totalAmount = 0;
this.froms.forEach((item,index)=>{
that.totalAmount += Number(item.price);
})
this.totalAmount = Number(Number(this.totalAmount) + Number(this.expressAmount)).toFixed(2);
},
flawSelect(i,title){
let flawId = this.froms[this.flawIndex].flaw_id;
if(flawId){
if(flawId.indexOf(i) > -1){
flawId.splice(flawId.indexOf(i),1);
this.froms[this.flawIndex].flaw_id = flawId;
}else{
this.froms[this.flawIndex].flaw_id.push(i);
}
}else{
this.froms[this.flawIndex].flaw_id.push(i);
}
let flaw = this.froms[this.flawIndex].flaw_id;
this.froms[this.flawIndex].flaw = '';
flaw.forEach((item,index)=>{
this.froms[this.flawIndex].flaw += (index == flaw.length-1 ? this.flaws[item].title : this.flaws[item].title+',');
});
if(this.froms[this.flawIndex].flaw_id.length < 1){
this.froms[this.flawIndex].flaw = '选择瑕疵';
}
},
submit() {
let that = this;
if(!this.subStatus){
return false;
}
console.log(this.froms);
this.$api.createWashOrder({goods:JSON.stringify(this.froms)}).then((res)=>{
if(res){
if(res.data.amount > 0){
WeixinJSBridge.invoke(
'getBrandWCPayRequest', res.data,
function(res){
if(res.err_msg == "get_brand_wcpay_request:ok" ){
that.$func.showToast('支付成功');
that.subStatus = true;

setTimeout(()=>{
window.location.reload();
},300);
}else{
that.$func.showToast('已取消支付');
}
that.closePop();
}
);
}else{
that.$func.showToast('提交成功');
that.subStatus = true;

setTimeout(()=>{
window.location.reload();
},300);
}
}
})
},
config(){
let url = (window.location.href).split('#');
if(url[0].indexOf('?') != '-1'){
url = url[0].split('?');
}
this.$api.wxSign({url:url[0]}).then((res)=>{
if(res){
wx.config({
debug: false,
appId: res.data.appId,
timestamp: res.data.timestamp,
nonceStr: res.data.nonceStr,
signature:res.data.signature,
jsApiList: [
"chooseImage",
"uploadImage",
"scanQRCode"
]
});
}
})
},
uploadFile(index){
let that = this;
this.picIndex = index;
wx.chooseImage({
count: 9,
sizeType: ['original', 'compressed'],
sourceType: ['album', 'camera'],
success: function (res) {
that.uploadImg(res.localIds);
}
});
},
uploadImg(localIds){
let that = this;
let localId = localIds.pop();
wx.uploadImage({
localId: localId,
success: function (res) {
that.$api.uploadsImgOss({serverId:res.serverId,path:'record'}).then((res)=>{
if(res){
that.froms[that.picIndex].filePath.push(res.data.pathName);
that.froms[that.picIndex].pics.push(res.data.saveName);
if(localIds.length > 0){
that.uploadImg(localIds);
}
}
})
}
});
},
showPic(i,index) {
wx.previewImage({
current: this.froms[i].filePath[index],
urls: [this.froms[i].filePath[index]]
});
},
delImg(i,index){
this.froms[i].filePath.splice(index,1);
this.froms[i].pics.splice(index,1);
},
openRecharge(){
this.rechargePop = true;
this.popUp = true;
},
recharge(){
if(this.amount <= 0){
this.$func.showToast('请输入充值金额');
return false;
}
if (typeof WeixinJSBridge == "undefined"){
if( document.addEventListener ){
document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
}else if (document.attachEvent){
document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
}
}else{
this.onBridgeReady();
}
},
onBridgeReady(){
let that = this;
this.$api.recharge({money:this.amount}).then((res)=>{
if(res){
WeixinJSBridge.invoke(
'getBrandWCPayRequest', res.data,
function(res){
if(res.err_msg == "get_brand_wcpay_request:ok" ){
that.$func.showToast('支付成功');
setTimeout(()=>{
that.getInfo();
},300);
}else{
that.$func.showToast('已取消支付');
}
that.closePop();
}
);
}
})
},
}
}



// WEBPACK FOOTER //
// ./src/pages/createWashOrder.vue